<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2s"><a id="page_xi"></a><a id="tra"></a>Note on Transliteration</h2>
<p class="noindent">F<span class="small">OR</span> A<span class="small">RABIC WORDS</span> and phrases that appear in this book, I followed the transliteration guide of the <em>International Journal of Middle East Studies</em>. I made an exception with regard to the Arabic names of individuals, in that I privileged the phonetic pronunciation in order to make them more accessible to an English-speaking audience. I also simplified the transliteration of well-known Arabic terms that are routinely used in English (for example, <em>intifada</em> or <em>Al Jazeera</em>) using their common spelling in English-speaking contexts.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tra.vue?5a896401